import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created.");
      navigate("/shop");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 pt-24 pb-28">
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8C3A3A] mb-5">Account</p>
      <h1 className="font-serif font-light text-5xl md:text-6xl tracking-tight text-[#1A1A1A] mb-10">Create Account</h1>
      <form onSubmit={submit} className="space-y-6" data-testid="register-form">
        {[["Full Name", "name", "text"], ["Email", "email", "email"], ["Password", "password", "password"]].map(([label, key, type]) => (
          <label className="block" key={key}>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#595959]">{label}</span>
            <input data-testid={`register-${key}`} type={type} required value={form[key]} onChange={set(key)} className="mt-2 w-full bg-transparent border border-[#E5E1D8] rounded-none px-4 py-3 font-sans text-sm focus:border-[#1A1A1A] outline-none transition-colors" />
          </label>
        ))}
        {error && <p data-testid="register-error" className="font-mono text-[11px] text-[#8C3A3A]">{error}</p>}
        <button type="submit" disabled={loading} data-testid="register-submit" className="w-full bg-[#1A1A1A] text-[#F9F8F6] py-4 font-mono text-[11px] uppercase tracking-[0.25em] hover:bg-[#8C3A3A] transition-colors disabled:opacity-50">
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>
      <p className="mt-8 font-sans text-sm text-[#595959]">
        Already have an account? <Link to="/login" className="text-[#8C3A3A] hover:underline">Sign in</Link>
      </p>
    </div>
  );
};

export default Register;
